import React from "react";
import { Col, Row } from "@payping/web-components";

import { useAppSelector } from "@/utils/redux";
import styles from "@/assets/scss/SummationTab.module.scss";
import DownloadApps from "./DownloadApps";
import FrequentOperations from "./FrequentOperations";
import PersonalPage from "./PersonalPage";
import Profile from "../Profile";
import ProfileProgress from "./ProfileProgress";
import TenDayChart from "./TenDayChart";

const SecondRow: React.FC = () => {
  const { totalTransactionCount } = useAppSelector((state) => state.reports);

  return (
    <Row justify="space-between" gutter={[32, 16]}>
      <Col xs={24} md={24} xl={6} style={{ height: "55vh" }}>
        <Row
          gutter={[16, 16]}
          // ? height: "100%" is for growing height of the Col in desktop view and,
          // ? keep in the same height of its neighboring elements
          className="h-100"
        >
          <Col xs={24} md={12} xl={24}>
            <ProfileProgress />
          </Col>
          <Col xs={24} md={12} xl={24}>
            <FrequentOperations />
          </Col>
          <Col xs={24} md={12} xl={24}>
            <PersonalPage />
          </Col>
          <Col xs={24} md={12} xl={24}>
            <DownloadApps />
          </Col>
        </Row>
      </Col>
      <Col xs={24} md={24} xl={18} className={styles.col}>
        {typeof totalTransactionCount !== "undefined" && totalTransactionCount < 1 ? (
          <Profile />
        ) : (
          <Row gutter={[0, 16]} className={"w-100"}>
            {/* height is applied for a render bug in safari */}
            <Col span={24} style={{ height: "55vh" }}>
              <TenDayChart />
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default SecondRow;
